import stCss from '../../st-css';
import {styleProps, textShorthandProps} from 'st-css';
import { spacingShorthandProps, visibilityShorthandProps } from 'st-css';

export const Text = stCss.canonize('p')(styleProps(textShorthandProps, spacingShorthandProps, visibilityShorthandProps));